import { NotificationDispatch, StyledNotificationContent } from '@tryhackme/thm-ui-components';
import { TypeOptions } from 'react-toastify';
export const displayToast = (type: TypeOptions, message: string) => NotificationDispatch(type, <StyledNotificationContent>
      <p>{message}</p>
    </StyledNotificationContent>);